<app-dialog class="orphan-municipality-dialog" [loading]="modalLoader">
  <ng-container dialog-title>
    {{ 'module.userProfile.regionalAdmin.assignToRegionText' | translate }}
  </ng-container>

  <ng-container dialog-content>
    <div class="text">
      {{ 'module.userProfile.regionalAdmin.municipalityNameText' | translate }}
      <span class="municipality">{{ municipality.municipalityName }} ({{ municipality.municipalityKey }})</span>
    </div>
    <div class="user-search" *ngIf="!!municipality && !municipality.primaryAdminGuid">
      <span class="search-label">{{ 'module.userProfile.regionalAdmin.assignKAMContactText' | translate }}: </span>
      <mat-form-field floatLabel="never" class="auto-complete">
        <input
          matInput
          type="text"
          [formControl]="newKamControl"
          placeholder="Neuen KAM suchen"
          [matAutocomplete]="kamAutoComplete"
          [errorStateMatcher]="kamErrorMatcher"
        />
        <mat-error *ngIf="true">Dieser Name ist im System nicht vorhanden. Bitte wählen Sie einen bestehenden KAM aus. </mat-error>
        <mat-autocomplete #kamAutoComplete="matAutocomplete" [displayWith]="displayKam">
          <mat-option *ngFor="let kam of filteredKams | async" [value]="kam">
            <small>{{ kam.name }}</small> <span class="light-gray"> | </span> <small class="light-gray">{{ kam.email }}</small>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="region-container">
      <div class="selection-container">
        <div class="subtext">{{ 'module.userProfile.regionalAdmin.chooseBackOfficeRegionText' | translate }}</div>
        <app-list-tree
          #backOfficeRegionTree
          [data]="backOfficeRegions"
          [itemSize]="20"
          [searchPlaceholder]="'Suche'"
          [multiple]="false"
          (selectEvent)="backOfficeSelected = true"
        ></app-list-tree>
      </div>
      <div class="selection-container">
        <div class="subtext">{{ 'module.userProfile.regionalAdmin.chooseServiceRegionText' | translate }}</div>
        <app-list-tree
          #serviceRegionTree
          [data]="serviceRegions"
          [itemSize]="20"
          [searchPlaceholder]="'Suche'"
          [multiple]="false"
          (selectEvent)="serviceRegionSelected = true"
        ></app-list-tree>
      </div>
      <div class="selection-container admin-region-tree">
        <div class="subtext">{{ 'module.userProfile.regionalAdmin.chooseAdminText' | translate }}</div>
        <app-list-tree
          #adminRegionTree
          [data]="adminRegions"
          [itemSize]="20"
          [searchPlaceholder]="'Suche'"
          [multiple]="false"
          (selectEvent)="adminRegionSelected = true"
        ></app-list-tree>
      </div>
    </div>
  </ng-container>

  <ng-container dialog-actions>
    <button class="btn btn-outline-primary" (click)="cancel()">
      {{ 'module.userProfile.regionalAdmin.cancelButtonText' | translate }}
    </button>
    <button class="btn btn-outline-primary" (click)="save()" [disabled]="!isFormValid">
      {{ 'module.userProfile.regionalAdmin.saveButtonText' | translate }}
    </button>
  </ng-container>
</app-dialog>
